<template>
  <div
    class="item tsiyun-item"
    @click="goToPage()"
    :position="page"
    :user="!isUser ? 1 : 2"
    :active="active"
    @mouseleave="hideHeader"
    @mouseenter="showHeader"
  >
    <span :class="{ 'user-tsiyun': isUser }" class="text" v-show="!editMode">{{
      title
    }}</span>
    <div v-show="editMode" class="relative w-100">
      <input
        @keydown.enter="save"
        ref="editBox"
        type="text"
        :value="title"
        class="input-change"
      />

      <div class="icons-change">
        <span @click.stop="save" class="otz-icon icon-v">A</span>
        <span class="otz-icon icon-x" @click.stop="editMode = false">F</span>
      </div>
    </div>
    <div class="flex">
      <div
        v-show="showButtons && !editMode"
        @click="removeUserTsiyun"
        class="otz-icon remove remove-user-tsiyun no-bg"
      >
        F
      </div>
      <div
        v-show="showButtons && !editMode"
        class="otz-icon remove-user-tsiyun no-bg"
        v-tooltip="{
          content: this.$t('tsiyunim.editTsiyun'),
          placement: 'right',
        }"
        @click.stop="doEdit"
      >
        c
      </div>
      <div
        class="show-mm-icom font-icon"
        v-if="mm && !$_mobile"
        @click="$emit('open-mm')"
      >
        j
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "book",
    "id",
    "title",
    "page",
    "isUser",
    "currentPage",
    "mm",
    "tabId",
    "active",
    "name",
  ],
  data() {
    return { editMode: false };
  },
  computed: {
    showButtons() {
      return this.isUser == true;
    },
  },
  watch: {
    currentPage: function (val, oldVal) {
      if (this.page !== val) return;
      if (this.$store.state.tabs[this.tabId].manualClickPage === this.page) {
        //this.manualClick = false;
        return;
      }
      let el = this.$el;
      if (this.page == val) el.scrollIntoViewIfNeeded({ behavior: "smooth" });
    },
  },
  methods: {
    showHeader() {
      this.$emit("mouseenter", {
        pageId: this.name,
        top: this.$el.getBoundingClientRect().top,
        left: this.$el.getBoundingClientRect().left,
        pos: this.page.originPosition || this.page.position,
      });
    },
    hideHeader() {
      this.$emit("mouseleave");
    },
    save() {
      if (this.$refs.editBox.value.trim() == "") return;
      this.$store.dispatch(`tabs/${this.tabId}/updateUserTsiyun`, {
        id: this.id,
        title: this.$refs.editBox.value,
        page: this.page,
      });
      this.editMode = false;
    },
    doEdit() {
      this.editMode = true;
      this.$nextTick(() => {
        this.$refs.editBox.select();
      });
    },
    async goToPage() {
      this.hideHeader();
      this.$store.state.tabs[this.tabId].manualClickPage = this.page;
      // this.manualClick = this.page;
      this.$nextTick(() => {
        this.$emit("click", this.page);
      });
    },
    async removeUserTsiyun() {
      await this.$store.dispatch(`tabs/${this.tabId}/delUserTsiyun`, {
        id: this.id,
      }); //.delUserTsiyun();

      let userTsiyuns =
        this.$store.getters[`tabs/${this.tabId}/getUserTsiyuns`]; //.; // this.getUserTsiyuns;
      this.$store.dispatch(`tabs/${this.tabId}/setUserTsiyuns`, userTsiyuns);

      // this.setCurrentTabUserTsiyuns({ userTsiyuns });
    },
  },
};
</script>

<style lang="scss" scoped>
.user-tsiyun {
  overflow: hidden;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  width: 100%;
}
.tsiyun-item {
  .remove-user-tsiyun {
    opacity: 0;
    display: none;
    width: 20px;
  }
  &:hover {
    .remove-user-tsiyun {
      opacity: 1;
      display: flex;
    }
  }
}
.show-mm-icom {
  cursor: pointer;
  z-index: 4;
  &:hover {
    color: #00000096;
  }
}
</style>
